import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html, body {
    overflow-x: hidden;
    max-width: 100vw;
  }

  @media (max-width: 768px) {
    .dashboard-header__content {
      padding: 0 16px;
    }

    .dashboard-header__nav {
      display: none;
    }

    main.has-mobile-menu {
      padding-bottom: 70px;
    }

    .notifications-popover {
      position: fixed;
      top: 74px;
      right: 16px;
      width: calc(100vw - 32px);
      max-width: none;
      border-radius: 18px;
    }
  }

  body {
    font-family: var(--font-body);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #f5f5f5;
    color: #333;
    line-height: 1.6;
  }

  /* Заголовки используют BebasNeuePro */
  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-heading);
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: 0.02em;
  }

  h1 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }

  h2 {
    font-size: 2rem;
    margin-bottom: 0.875rem;
  }

  h3 {
    font-size: 1.75rem;
    margin-bottom: 0.75rem;
  }

  h4 {
    font-size: 1.5rem;
    margin-bottom: 0.625rem;
  }

  h5 {
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  }

  h6 {
    font-size: 1rem;
    margin-bottom: 0.375rem;
  }

  /* Классы для заголовков с BebasNeuePro */
  .heading-primary {
    font-family: var(--font-heading);
    font-weight: 700;
    font-size: 2.5rem;
    line-height: 1.2;
    letter-spacing: 0.02em;
  }

  .heading-secondary {
    font-family: var(--font-heading);
    font-weight: 700;
    font-size: 2rem;
    line-height: 1.2;
    letter-spacing: 0.02em;
  }

  .heading-tertiary {
    font-family: var(--font-heading);
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.2;
    letter-spacing: 0.02em;
  }

  .heading-small {
    font-family: var(--font-heading);
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.2;
    letter-spacing: 0.02em;
  }

  /* Классы для обычного текста с Segoe UI */
  .text-body {
    font-family: var(--font-body);
    font-weight: normal;
    line-height: 1.6;
  }

  .text-body-bold {
    font-family: var(--font-body);
    font-weight: bold;
    line-height: 1.6;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
    font-family: inherit;
  }

  input, textarea, select {
    font-family: inherit;
    border: none;
    outline: none;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .btn {
    font-family: var(--font-body);
    padding: 12px 24px;
    border-radius: 5px;
    font-weight: 600;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border: none;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.4;
  }

  .btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }

  .btn-primary {
    background-color: #4CAF50;
    color: white;
  }

  .btn-primary:hover {
    background-color: #45a049;
  }

  .btn-secondary {
    background-color: #FF9800;
    color: white;
  }

  .btn-secondary:hover {
    background-color: #f57c00;
  }

  .btn-outline {
    background-color: transparent;
    color: #4CAF50;
    border: 2px solid #4CAF50;
  }

  .btn-outline:hover {
    background-color: #4CAF50;
    color: white;
  }

  .btn-white {
    background-color: white;
    color: #333;
    border: 2px solid #ddd;
  }

  .btn-white:hover {
    background-color: #f8f9fa;
    border-color: #ccc;
  }

  .text-center {
    text-align: center;
  }

  .text-left {
    text-align: left;
  }

  .text-right {
    text-align: right;
  }

  .mb-0 { margin-bottom: 0; }
  .mb-1 { margin-bottom: 8px; }
  .mb-2 { margin-bottom: 16px; }
  .mb-3 { margin-bottom: 24px; }
  .mb-4 { margin-bottom: 32px; }
  .mb-5 { margin-bottom: 40px; }

  .mt-0 { margin-top: 0; }
  .mt-1 { margin-top: 8px; }
  .mt-2 { margin-top: 16px; }
  .mt-3 { margin-top: 24px; }
  .mt-4 { margin-top: 32px; }
  .mt-5 { margin-top: 40px; }

  .grid {
    display: grid;
    gap: 20px;
  }

  .flex {
    display: flex;
  }

  .flex-column {
    flex-direction: column;
  }

  .justify-center {
    justify-content: center;
  }

  .justify-between {
    justify-content: space-between;
  }

  .align-center {
    align-items: center;
  }

  .hidden {
    display: none;
  }

  // Dashboard стили
  .dashboard-wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .dashboard-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 40px 20px;
    flex: 1;
  }

  .dashboard-header {
    background: #323232;
    color: white;
    padding: 0;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 1000;
  }

  .dashboard-header__content {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
  }

  .dashboard-header__logo {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 600;
    color: white;
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .dashboard-header__logo:hover {
    transform: scale(1.02);
  }

  .dashboard-header__logo img {
    transition: transform 0.3s ease;
  }

  .dashboard-header__logo:hover img {
    transform: scale(1.05);
  }

  .dashboard-header__logo span {
    font-size: 24px;
  }

  .dashboard-header__nav {
    display: flex;
    gap: 30px;
    align-items: center;
  }

  .dashboard-header__nav-link {
    color: white;
    text-decoration: none;
    font-weight: 500;
    padding: 8px 16px;
    border-radius: 8px;
    transition: all 0.3s ease;
    position: relative;
  }

  .dashboard-header__nav-link:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  .dashboard-header__nav-link.active {
    background: rgba(255, 255, 255, 0.2);
  }

  .dashboard-header__user-section {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .notifications-wrapper {
    position: relative;
  }

  .notifications-trigger {
    position: relative;
    min-width: 40px;
    min-height: 40px;
  }

  .notifications-trigger.is-active {
    background: rgba(255, 255, 255, 0.2);
  }

  .notifications-badge {
    position: absolute;
    top: -4px;
    right: -2px;
    background: rgb(255, 107, 53);
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    border-radius: 999px;
    padding: 2px 6px;
    pointer-events: none;
    box-shadow: 0 2px 6px rgba(255, 107, 53, 0.4);
  }

  .notifications-popover {
    position: absolute;
    top: calc(100% + 12px);
    right: 0;
    width: 400px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 18px 45px rgba(15, 23, 42, 0.18);
    border: 1px solid rgba(148, 163, 184, 0.25);
    overflow: hidden;
    transform: translateY(-6px);
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
    z-index: 1000;
  }

  .notifications-popover--open {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .notifications-popover__header {
    padding: 16px 20px;
    border-bottom: 1px solid #eef2f7;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    color: #1f2937;
  }

  .notifications-popover__loading {
    font-size: 12px;
    font-weight: 500;
    color: #9ca3af;
  }

  .notifications-popover__list {
    max-height: 240px;
    overflow-y: auto;
  }

  .notifications-popover__item {
    padding: 14px 20px;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .notifications-popover__item:last-child {
    border-bottom: none;
  }

  .notifications-popover__item-title {
    font-weight: 600;
    font-size: 14px;
    color: #111827;
  }

  .notifications-popover__item--unread .notifications-popover__item-title {
    font-weight: 700;
    color: rgb(204, 86, 42);
  }

  .notifications-popover__item-message {
    font-size: 13px;
    color: #4b5563;
    line-height: 1.4;
  }

  .notifications-popover__item-date {
    font-size: 11px;
    color: #9ca3af;
  }

  .notifications-popover__item--unread {
    background: #f5f5f5;
    border-left: 4px solid rgb(255, 107, 53);
    padding-left: 19px;
  }

  .notifications-popover__empty {
    padding: 32px 20px;
    text-align: center;
    font-size: 14px;
    color: #6b7280;
  }

  .notifications-popover__footer {
    width: 100%;
    padding: 14px 20px;
    background: #f8fafc;
    color: rgb(255, 107, 53);
    font-weight: 600;
    border-top: 1px solid #eef2f7;
    transition: background 0.2s ease;
    cursor: pointer;
    border: none;
  }

  .notifications-popover__footer:hover {
    background: rgba(255, 107, 53, 0.1);
  }

  .icon-button {
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: white;
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }

  .icon-button:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 8px;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    min-width: 200px;
    z-index: 1000;
    overflow: hidden;
    transform-origin: top right;
    transform: scale(0.95) translateY(-10px);
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
  }

  .dropdown-menu--open {
    transform: scale(1) translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .dashboard-footer {
    background: #323232;
    border-top: 1px solid #e9ecef;
    padding: 20px 0;
    margin-top: auto;
  }

  .dashboard-footer__content {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
    text-align: center;
  }

  .dashboard-footer__copyright {
    color: #6c757d;
    font-size: 14px;
    margin: 0;
  }

  // Dashboard страницы
  .dashboard-welcome {
    background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
    color: white;
    padding: 30px;
    border-radius: 15px;
    margin-bottom: 30px;
    text-align: center;
  }

  .dashboard-welcome__title {
    font-family: 'BebasNeuePro', 'Arial Black', 'Helvetica Bold', sans-serif;
    font-weight: 700;
    font-size: 28px;
    margin-bottom: 10px;
    line-height: 1.2;
  }

  .dashboard-welcome__date {
    font-size: 14px;
    opacity: 0.9;
    margin: 0;
  }

  .dashboard-top-section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
  }

  .dashboard-card {
    background: white;
    padding: 25px;
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }

  .dashboard-card--account {
    border-left: 4px solid #4CAF50;
  }

  .dashboard-card--bonus {
    border-left: 4px solid #2196F3;
  }

  .dashboard-card--rank {
    border-left: 4px solid #FF9800;
  }

  .dashboard-card__title {
    font-family: 'SegoeUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    font-size: 16px;
    color: #666;
    margin-bottom: 15px;
    font-weight: 500;
  }

  .dashboard-card__amount {
    font-family: 'BebasNeuePro', 'Arial Black', 'Helvetica Bold', sans-serif;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 10px;
    line-height: 1.2;
  }

  .dashboard-card__amount--primary {
    color: #4CAF50;
  }

  .dashboard-card__amount--secondary {
    color: #2196F3;
  }

  .dashboard-rank-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }

  .dashboard-rank-title {
    font-family: 'SegoeUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    font-size: 16px;
    color: #666;
  }

  .dashboard-rank-badge {
    background: #FF9800;
    color: white;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
  }

  .dashboard-rank-badge--current {
    background: #666;
  }

  .dashboard-rank-badge--next {
    background: #FF9800;
  }

  .dashboard-rank-condition {
    font-size: 12px;
    color: #999;
    margin-top: 5px;
  }

  .dashboard-main-content {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 30px;
    margin-bottom: 30px;
  }

  .dashboard-left-column {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .dashboard-right-column {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .dashboard-action-card {
    background: white;
    padding: 25px;
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }

  .dashboard-action-title {
    font-family: 'BebasNeuePro', 'Arial Black', 'Helvetica Bold', sans-serif;
    font-weight: 700;
    font-size: 18px;
    color: #333;
    margin-bottom: 20px;
    line-height: 1.2;
  }

  .dashboard-action-buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  .dashboard-action-button {
    background: white;
    color: #4CAF50;
    border: 2px solid #4CAF50;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .dashboard-action-button:hover {
    background: #4CAF50;
    color: white;
  }

  .dashboard-action-button--primary {
    background: #4CAF50;
    color: white;
  }

  .dashboard-action-button--primary:hover {
    background: #45a049;
  }

  .dashboard-marketing-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-top: 15px;
  }

  .dashboard-stat-item {
    text-align: center;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 10px;
  }

  .dashboard-stat-number {
    font-family: 'BebasNeuePro', 'Arial Black', 'Helvetica Bold', sans-serif;
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin-bottom: 5px;
    line-height: 1.2;
  }

  .dashboard-stat-label {
    font-family: 'SegoeUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    font-size: 12px;
    color: #666;
  }

  .dashboard-page-title {
    font-family: 'BebasNeuePro', 'Arial Black', 'Helvetica Bold', sans-serif;
    font-weight: 700;
    font-size: 24px;
    color: #333;
    margin-bottom: 20px;
    line-height: 1.2;
  }

  // Адаптивные брейкпоинты
  @media (max-width: 1024px) {
    .dashboard-header__nav {
      display: none !important;
    }
    
    .mobile-nav-links {
      display: block !important;
    }
  }

  @media (max-width: 768px) {
    .container {
      padding: 0 15px;
    }
    
    .btn {
      padding: 10px 20px;
      font-size: 13px;
    }

    .dashboard-container {
      padding: 20px 15px;
    }

    .dashboard-header__content {
      padding: 0 15px;
      height: 60px;
    }

    .dashboard-header__logo {
      font-size: 16px;
    }

    .dashboard-header__logo span {
      font-size: 20px;
    }

    .dashboard-top-section {
      grid-template-columns: 1fr;
      gap: 15px;
    }

    .dashboard-main-content {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    .dashboard-welcome__title {
      font-size: 22px;
    }

    .dashboard-card {
      padding: 20px;
    }

    .dashboard-action-card {
      padding: 20px;
    }

    .dashboard-marketing-stats {
      grid-template-columns: 1fr;
      gap: 15px;
    }
  }

  @media (max-width: 480px) {
    .container {
      padding: 0 10px;
    }
    
    .btn {
      padding: 8px 16px;
      font-size: 12px;
    }

    .dashboard-container {
      padding: 15px 10px;
    }

    .dashboard-header__content {
      padding: 0 10px;
      height: 55px;
    }

    .dashboard-header__logo {
      font-size: 14px;
    }

    .dashboard-header__logo span {
      font-size: 18px;
    }

    .dashboard-welcome {
      padding: 20px;
    }

    .dashboard-welcome__title {
      font-size: 20px;
    }

    .dashboard-card {
      padding: 15px;
    }

    .dashboard-action-card {
      padding: 15px;
    }

    .dashboard-action-buttons {
      flex-direction: column;
    }

    .dashboard-action-button {
      width: 100%;
      text-align: center;
    }
  }
  
  @media (max-width: 410px) {
    .container {
      padding: 0 8px;
    }
    
    .btn {
      padding: 8px 14px;
      font-size: 12px;
    }

    .dashboard-container {
      padding: 12px 8px;
    }

    .dashboard-header__content {
      padding: 0 8px;
      height: 50px;
      gap: 8px;
    }

    .dashboard-header__logo {
      font-size: 13px;
    }

    .dashboard-header__logo span {
      font-size: 16px;
    }
    
    .dashboard-header__logo img {
      height: 32px;
    }

    .dashboard-welcome {
      padding: 15px;
      border-radius: 12px;
      margin-bottom: 15px;
    }

    .dashboard-welcome__title {
      font-size: 18px;
    }

    .dashboard-card {
      padding: 12px;
      border-radius: 12px;
    }
    
    .dashboard-card__title {
      font-size: 14px;
      margin-bottom: 10px;
    }
    
    .dashboard-card__amount {
      font-size: 20px;
    }

    .dashboard-action-card {
      padding: 12px;
      border-radius: 12px;
    }
    
    .dashboard-action-title {
      font-size: 16px;
      margin-bottom: 15px;
    }

    .dashboard-action-buttons {
      flex-direction: column;
      gap: 8px;
    }

    .dashboard-action-button {
      width: 100%;
      text-align: center;
      padding: 10px 16px;
      font-size: 13px;
    }
    
    .dashboard-top-section {
      gap: 12px;
      margin-bottom: 15px;
    }
    
    .dashboard-stat-number {
      font-size: 20px;
    }
    
    .dashboard-stat-label {
      font-size: 11px;
    }
    
    .icon-button {
      padding: 6px;
      font-size: 14px;
    }
    
    .notifications-badge {
      font-size: 9px;
      padding: 1px 5px;
    }
  }
`;

export const theme = {
  colors: {
    primary: '#4CAF50',
    secondary: '#FF9800',
    accent: '#2196F3',
    dark: '#333',
    light: '#f5f5f5',
    white: '#ffffff',
    gray: '#666',
    lightGray: '#e0e0e0',
    success: '#4CAF50',
    warning: '#FF9800',
    error: '#f44336',
    info: '#2196F3'
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    large: '1200px'
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },
  borderRadius: {
    sm: '3px',
    md: '5px',
    lg: '8px',
    xl: '12px',
    round: '50%'
  },
  shadows: {
    sm: '0 2px 4px rgba(0,0,0,0.1)',
    md: '0 4px 8px rgba(0,0,0,0.12)',
    lg: '0 8px 16px rgba(0,0,0,0.15)',
    xl: '0 12px 24px rgba(0,0,0,0.18)'
  }
};

export default GlobalStyles; 